/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {message} from 'antd'
import Page, {page} from '../Pagination/Pagination'
import HeaderTable from '../BaseComponent/HeaderTable'
import {Link} from 'react-router-dom'
import jMoment from 'moment-jalali'
import {accounting} from 'accounting'
import cookie from 'react-cookies'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import ProductReportComponent from '../BaseComponent/productReportComponent'
import ProductReportPrint from '../BaseComponent/productReportPrint'

class ProductPlanFromDispatch extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      products: [],
      printInfo: [],
      aggregation: {}
    }
  }

  componentDidMount() {
    sessionStorage.removeItem('params')

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    var {dispatchId} = this.props.match.params

    sessionStorage.setItem('params', `dispatchId=${dispatchId}`)
    sessionStorage.setItem('dispatchId', `${dispatchId}`)

    http
      .get(
        `${
          REPORT_DISPATCH.REPORT_DISPATCH_PRODUCT_BYDISPATCH
        }?export=false&pageSize=10&pageNumber=1&dispatchId=${dispatchId}`,
        {}
      )
      .then((response) => {
        if (response.data.error == null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)

          this.setState({
            products: response.data.object.result,
            lengthProducts: response.data.object.countAll,
            aggregation: response.data.object.aggregation
          })
        } else {
          message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  onResultFetched(data) {
    this.setState({
      products: data
    })
  }

  changeDropDown(data) {
    this.setState({
      products: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  getPrintInfo = () => {
    http
      .get(`${REPORT_DISPATCH.REPORT_DISPATCH_PRODUCT_BYDISPATCH}?export=true&${sessionStorage.getItem('params')}`, {})
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)

          this.setState({
            printInfo: response.data.object.result,
            aggregation: response.data.object.aggregation
          })
        } else {
          message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 landscape;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  exportExcel = () => {
    http
      .get(
        `${
          REPORT_DISPATCH.REPORT_DISPATCH_PRODUCT_BYDISPATCH
        }?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem('params')}`,
        {}
      )
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          console.log(response.data)
          // $('.showBaseTable,.print').fadeIn();

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['discount'] = excelReport[i]['discountAmount'] + excelReport[i]['extraDiscountAmount']
          }

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })

    // this._export.save(excelData)
  }

  render() {
    let urlParams = sessionStorage.getItem('params')

    let excelColumns = [
      {title: 'نام محصول', value: 'productName'},
      {title: 'کد محصول', value: 'productCode'},
      {title: 'نام تامین کننده', value: 'providerName'},
      {title: 'تعداد', value: 'productCount'}
    ]
    const {name} = this.props.match.params

    return (
      <div className="rtl printA4Page">
        <ProductReportPrint
          printInfo={this.state.printInfo}
          centerTitle={'گزارش کالا های رساننده : ' + name}
          aggregation={this.state.aggregation}
          centerSectionPrint={''}
          rightSectionPrint={'در تاریخ : ' + jMoment(Number(this.props.match.params.planDate)).format('jYY/jMM/jDD')}
        />

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName={'گزارش کالا های رساننده : ' + name + '.xls'}
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'productName'}
                field={'productName'}
                title={'نام محصول'}
                width="200px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'productCode'}
                field={'productCode'}
                title={'کد محصول'}
                width="200px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'providerName'}
                field={'providerName'}
                title={'تامین کننده'}
                width="200px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'deliveryCount'}
                field={'deliveryCount'}
                title={'تعداد پارت تحویل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'productQuantityCount'}
                field={'productQuantityCount'}
                title={'تعداد'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'productQuantityValue'}
                field={'productQuantityValue'}
                title={'مقدار'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'productUnitTitle'}
                field={'productUnitTitle'}
                title={'واحد'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'totalAmount'}
                field={'totalAmount'}
                title={'قیمت کل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'discount'}
                field={'discount'}
                title={'تخفیف'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'payableAmount'}
                field={'payableAmount'}
                title={'قابل پرداخت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>{'کالا های رساننده'}</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl=""
                  url={REPORT_DISPATCH.REPORT_DISPATCH_PRODUCT_BYDISPATCH}
                  showRow={false}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printUrl="test"
                  printComponent={this.printTable}
                  execelUrl={REPORT_DISPATCH.REPORT_DISPATCH_PRODUCT_BYDISPATCH + '/?export=true'}
                  excelColumns={excelColumns}
                  titleAdd=""
                  printLink=""
                />

                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>

                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>

            <div className="detailsInfoTable">
              <ul>
                <li>کالا های رساننده : {name}</li>
                <li>در تاریخ :‌{jMoment(Number(this.props.match.params.planDate)).format('jYY/jMM/jDD')}</li>
              </ul>
            </div>
            <ProductReportComponent
              products={this.state.products}
              aggregation={this.state.aggregation}
              personId={''}
              planDateMin={''}
              planDateMax={''}
              dayPartId={''}
              name={this.props.match.params.name}
              planDate={this.props.match.params.planDate}
              productFrom="dispatch"
            />
            <div className="paginationWrapp">
              <Page
                defaultCurrent={1}
                total={this.state.lengthProducts}
                onResultFetched={this.onResultFetched.bind(this)}
                url={REPORT_DISPATCH.REPORT_DISPATCH_PRODUCT_BYDISPATCH}
                urlParams={urlParams}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ProductPlanFromDispatch
